import { lighten, Switch } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";

export const useSwitchStyles = makeStyles((theme) => ({
  switchBase: {
    "&:hover": {
      background: "transparent",
      "& $thumb": {
        boxShadow: `0 0 0 4px ${theme.palette.grey[200]}`,
      },
    },
    "&$checked": {
      "&:hover": {
        "& $thumb": {
          boxShadow: `0 0 0 4px ${lighten(theme.palette.primary.main, 0.8)}`,
        },
      },
    },
  },
  input: {
    "&:focus": {
      "& + $thumb": {
        background: theme.palette.grey[700],
      },
    },
  },
  track: {
    background: theme.palette.grey[400],
  },
  thumb: {
    background: theme.palette.grey[600],
  },
  checked: {
    "& + $track": {
      backgroundColor: `${theme.palette.grey[50]} !important`,
      border: `1px solid ${theme.palette.grey[500]}`,
    },
    "& $thumb": {
      background: theme.palette.primary.main,
    },
    "& $input:focus": {
      "& + $thumb": {
        background: theme.palette.primary.dark,
      },
    },
  },
  disabled: {
    "& $thumb": {
      background: theme.palette.grey[300],
    },
  },
}));

export const PrimarySwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.palette.primary.main,
    "&$checked": {
      color: theme.palette.primary.main,
    },
    "&$checked + $track": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checked: {},
  track: { backgroundColor: theme.palette.primary.main },
}))(Switch);
